const monthToHeb = { Jan: 'ינואר', Feb: 'פברואר', Mar: 'מרץ', Apr: 'אפריל', May: 'מאי', Jun: 'יוני', Jul: 'יולי', Aug: 'אוגוסט', Sep: 'ספטמבר', Oct: 'אוקטובר', Nov: 'נובמבר', Dec: 'דצמבר' }
export const translateMonth = (str: string) => {
    const [month] = (str.match(/(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)/) ?? []) as (keyof typeof monthToHeb)[];
    return str.replace(month, monthToHeb[month]);
}